import * as z from "zod/v4";
import {
  MarketingAgentAnalyticsInputSchema,
  MetricWithComparisonSchema,
} from "./common";

export const getMarketingAgentPerformanceMetrics = {
  name: "getMarketingAgentPerformanceMetrics" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.object({
    totalSends: MetricWithComparisonSchema,
    totalMessageCost: MetricWithComparisonSchema,
    totalLlmCost: MetricWithComparisonSchema,
    totalCost: MetricWithComparisonSchema,
    currentAttributedOrders: MetricWithComparisonSchema,
    currentAttributedRevenue: MetricWithComparisonSchema,
    altAttributedOrders: MetricWithComparisonSchema,
    altAttributedRevenue: MetricWithComparisonSchema,
  }),
};
